import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { OneModal } from '@factorialco/f0-react/dist/experimental'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { DataCatalogSelector } from 'modules/ai_reports/components/DataCatalogSelector'
import { useDataCatalogSelector } from 'modules/ai_reports/components/DataCatalogSelector/useDataCatalogSelector'
import { LoadingBlock } from 'modules/ai_reports/components/LoadingBlock'
import { getSlugFromTableId } from 'modules/ai_reports/lib/slug-tableid-mapping'

export type NewExporationDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const NewExplorationModal = ({ open, onOpenChange }: NewExporationDialogProps) => {
  const [localOpen, setLocalOpen] = useState(open)

  const { navigation } = useNavigation()
  const navigate = useNavigate()

  useEffect(() => {
    setLocalOpen(open)
  }, [open, setLocalOpen])

  useEffect(() => {
    onOpenChange(localOpen)
  }, [localOpen, onOpenChange])

  const { datasources, loading, error } = useDataCatalogSelector()

  const [selectedDatasourceId, setSelectedDatasourceId] = useState<string | undefined>(undefined)

  return (
    <OneModal onClose={() => setLocalOpen(false)} isOpen={localOpen}>
      <OneModal.Header title={i18n.t('ai_reports.reports.new_exploration')} />
      <OneModal.Content>
        <Box
          maxWidth="full"
          height="s400"
          maxHeight="full"
          flexGrow
          style={{
            height: '400px',
            flex: '1',
            display: 'flex',
          }}
        >
          {error ? (
            <>{error.message}</>
          ) : (
            <>
              {loading && <LoadingBlock />}
              {!loading && (
                <DataCatalogSelector
                  datasources={datasources ?? []}
                  sourceId={selectedDatasourceId}
                  onSelectDatasource={setSelectedDatasourceId}
                />
              )}
            </>
          )}
        </Box>
      </OneModal.Content>
      <OneModal.Footer>
        <Box flexDirection="row" justifyContent="flexEnd" gap="s12" width="full">
          <F0Button
            variant="outline"
            onClick={() => setLocalOpen(false)}
            label={i18n.t('common.cancel')}
          />
          <F0Button
            disabled={!selectedDatasourceId}
            onClick={() => {
              selectedDatasourceId &&
                navigate(
                  navigation.aiReports.catalog.slug.new.fullPath({
                    slug: getSlugFromTableId(selectedDatasourceId),
                  })
                )
            }}
            label={i18n.t('ai_reports.reports.new_exploration')}
          />
        </Box>
      </OneModal.Footer>
    </OneModal>
  )
}
